var viewer_default = {
  "gallery_container": "Jxvqg",
  "imageTitleContainer": "_9gr9Y",
  "clickableItem": "COaT8",
  "prerender": "ywLrW",
  "expandButton": "_9hoAJ",
  "itemContainer": "WC27A",
  "expandIcon": "SdK0z",
  "itemOverlay": "G6w-W",
  "imageTitle": "vqTGc",
  "pointer": "ryPNb",
  "fadeIn": "RTIpm",
  "changing_background": "Kc9BK"
};
export {
  viewer_default as default
};
//# sourceMappingURL=viewer-scss.js.map
